module.exports = __webpack_public_path__ + "static/media/bg5.56fed139.jpg";